import React, { forwardRef, memo } from 'react';
import { Flex } from 'theme-ui';
import type { FlexProps } from 'theme-ui';
export {
  Flex,
  Box,
  Container,
  Heading,
  Card,
  Text,
  Button,
  IconButton,
  Divider,
  Slider,
  Select,
  Checkbox,
  Badge,
  Grid,
  Link,
  Input,
  Close,
  MenuButton,
  Alert,
  Switch,
  Textarea,
  Spinner,
} from 'theme-ui';
export * from './carbon';
export * from '../nav';

export const Column = memo(
  forwardRef<HTMLDivElement, FlexProps>(
    ({ children, variant = 'column', sx, ...props }, ref) => (
      <Flex
        sx={sx}
        {...props}
        ref={ref}
        variant={variant.match(/\./) ? variant : `flex.${variant}`}
      >
        {children}
      </Flex>
    )
  )
);

export const Row = memo(
  forwardRef<HTMLDivElement, FlexProps>(
    ({ children, variant = 'row', sx, ...props }, ref) => (
      <Flex
        sx={sx}
        {...props}
        ref={ref}
        variant={variant.match(/\./) ? variant : `flex.${variant}`}
      >
        {' '}
        {children}
      </Flex>
    )
  )
);
